import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, skip, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { NotificationService } from '@core/services/notification/notification.service';
import { SearchService } from '@core/services/search.service';
import { ProductDetailViewModel } from '@models/api-search.models';

@Injectable({
    providedIn: 'root'
})
export class ProductDetailService {
    private productDetailLoadingBs$ = new BehaviorSubject<boolean>(false);
    private productDetailBs$ = new BehaviorSubject<ProductDetailViewModel | null>(null);
    public activeId: string;
    public productDetail$: Observable<ProductDetailViewModel | null> = this.productDetailBs$.asObservable();
    public productDetailLoading$: Observable<boolean> = this.productDetailLoadingBs$.asObservable();

    constructor(
        private readonly notificationService: NotificationService,
        private readonly searchService: SearchService
    ) {
        this.productDetail$.subscribe(val => {
            if (val) {
                this.activeId = val.variantNo;
            }
        });
    }

    public setProduct(product: ProductDetailViewModel): void {
        this.productDetailBs$.next(product);
    }

    public requestProduct(productId: string): Observable<ProductDetailViewModel | null> {
        if (productId === this.activeId) {
            return of(null);
        }

        this.productDetailLoadingBs$.next(true);
        this.searchService
            .getProduct(productId)
            .pipe(
                take(1),
                catchError(error => throwError(error))
            )
            .subscribe(
                product => {
                    this.productDetailBs$.next(product);
                    this.productDetailLoadingBs$.next(false);
                },
                error => {
                    // Set loading to false, and reemit last known value
                    this.productDetailLoadingBs$.next(false);
                    this.productDetailBs$.next(this.productDetailBs$.value);
                    this.notificationService.createNotification({
                        ...(error.message ? { messageText: error.message } : {})
                    });
                }
            );
        return this.productDetail$.pipe(skip(1));
    }

    public resetProduct(): void {
        this.productDetailBs$.next(null);
    }
}
